/* tslint:disable */
import {
  Game,
  Content,
  Translation
} from '../index';

declare var Object: any;
export interface GameCategoryInterface {
  "name": string;
  "image": string;
  "id"?: any;
  games?: Game[];
  contents?: Content[];
  translations?: Translation[];
}

export class GameCategory implements GameCategoryInterface {
  "name": string;
  "image": string;
  "id": any;
  games: Game[];
  contents: Content[];
  translations: Translation[];
  constructor(data?: GameCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `GameCategory`.
   */
  public static getModelName() {
    return "GameCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of GameCategory for dynamic purposes.
  **/
  public static factory(data: GameCategoryInterface): GameCategory{
    return new GameCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'GameCategory',
      plural: 'game-categories',
      path: 'game-categories',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "image": {
          name: 'image',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        games: {
          name: 'games',
          type: 'Game[]',
          model: 'Game',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'categoryId'
        },
        contents: {
          name: 'contents',
          type: 'Content[]',
          model: 'Content',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'categoryId'
        },
        translations: {
          name: 'translations',
          type: 'Translation[]',
          model: 'Translation',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'translationableId'
        },
      }
    }
  }
}
